module.exports = __webpack_public_path__ + "img/qrcode.44d723aa.png";